import { Pipe, PipeTransform } from '@angular/core';
import { Moment } from 'moment';

@Pipe({
    name: 'momentFormat'
})
export class MomentFormatPipe implements PipeTransform {
    transform(value: Moment) {
        return `${value.date()}/${value.month() + 1}/${value.year()}`;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/moment.pipe/moment.pipe.ts